
export function Api_route(route){
    return "https://torapos-live.herokuapp.com/"+route;

}